module.exports = __webpack_public_path__ + "img/trustpilot.1f5d36af.png";